<app-loader *ngIf="mostrarLoader"></app-loader>
<div class="page-wrapper">
    <div class="container-fluid p-0">
        <div class="row">
            <div class="col-12">
                <div class="login-card">
                    <div>
                        <div>
                            <a class="logo" routerLink='/'>
                                <img class="img-fluid for-light" src="assets/images/login/logo1.png" width="300"
                                    alt="looginpage">
                                <img class="img-fluid for-dark" src="assets/images/login/logo1.png" width="300"
                                    alt="looginpage">
                            </a>
                        </div>
                        <div class="login-main">
                            <form class="theme-form">
                                <h4>Recuperar nombre de usuario</h4>
                                <div class="form-group">
                                    <label class="col-form-label">Ingresá tu número de documento sin puntos</label>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <input [(ngModel)]="numeroDocumento" class="form-control mb-1"
                                                [maxlength]="8" required="" type="text" placeholder="12345678"
                                                (input)="onInputChange($event)">
                                        </div>
                                        <div class="col-12" *ngIf="mostrar">
                                            <button class="btn btn-primary btn-pill d-block w-100 m-t-10 " type="submit"
                                                (click)="resetPassword()">Enviar</button>
                                        </div>
                                        <div class="text-center mt-4 mb-4">
                                            <span class="reset-password-link">Aun no sos paciente?  <a
                                                    class="btn-link text-primary" style="text-decoration: none;"
                                                    [routerLink]="'/register'">Registrate
                                                    aquí</a></span>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>